import FilterV3 from '@components/FilterV3/FilterV3';
import { ListScreenFiltersConfig } from '../listScreen.types';

interface ListScreenFilterBarProps {
  filters: ListScreenFiltersConfig;
}

export function ListScreenFilterBar({ filters }: ListScreenFilterBarProps) {
  return (
    <FilterV3
      unifiedBar
      list={filters.preferenceList}
      options={filters.options}
      searchField={filters.searchField}
      isSearchActive={filters.isSearchActive}
      onClearSearch={filters.onClearSearch}
      FixedFilters={filters.fixedFilters}
    />
  );
}
